<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="taskHeader" class="page-name color-71aa3f">
                        Create Resale Reason
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backshowtask">Back</button>
                </div>
                <div v-if="isDataEditable == true">
                    <div class="admin-page-content">
                        <form id="resaleReasonform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span>Resale Added Successfully</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg" class="error"></span>
                                        </div>
                                    </div>


                                    <!-- Resale Reason -->
                                        <div class="col-6 forms-block">
                                            <div class="col-3 paddingleft0">
                                                <div class="form-label"><strong>Resale Reason</strong></div>
                                            </div>
                                            <div class="col-9 paddingleft0">
                                                <input type="text" id="resale_reason" name="resale_reason" class="form-control"
                                                      placeholder="Enter Resale Reason" v-model="resale_reason">
                                                <!--v-validate="'required|max:190'">-->
                                                <!--div class="requiredstar">*</div>
                                                <span v-if="errors.has('resale_no')" v-show="resale_no == ''" class="help is-danger"><font color="red">Resale Number is required</font></span-->
                                                <!--<span v-if="errors.firstByRule('subject','max')" v-show="subject != ''" class="help is-danger"><font color="red">Subject maximum length must be 190 characters</font></span>-->
                                            </div>
                                        </div>


                                      <!--div class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created By</strong> : {{ firstName }} {{ lastName }}</div>
                                            </div>
                                      </div>
                                      <div v-if="is_update"  class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated By</strong> : {{ u_firstName }} {{ u_lastName }}</div>
                                            </div>
                                      </div>
                                      <div class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Created at</strong> : {{ created_at }}</div>
                                            </div>
                                      </div>
                                      <div v-if="is_update"  class="desktol-created-data col-md-6 col-sm-12 forms-block">
                                            <div class="col-12 paddingleft0">
                                                <div class="form-label"><strong>Updated at</strong> : {{ updated_at }}</div>
                                            </div>
                                      </div-->

                                    <div class="col-12 mt-2">
                                        <div class="col-12 paddingleft0">
                                            <input id="addTaskBtn" type="submit" value="Save" class="btn general-button btn-primary" v-on:click.prevent="AddResaleReason()">
                                            <!-- <button style="float: left" id="addCaseBtn" type="submit" class="btn general-button btn-primary" v-on:click.prevent="addCase">{{btn}}</button> -->
                                            <input id="addAndContinueTaskBtn" type="submit" value="Save and Continue" class="btn general-button btn-primary" v-on:click.prevent="AddResaleReason(flag='Save and Continue')">
                                            <input id="CancelTask" type="submit" value="Cancel" class="btn general-button btn-primary" v-on:click.prevent="backshowtask">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div v-if="isDataEditable == false" >
                    <div class="admin-page-content">
                        <div class="col-md-12 error-detail-main forms-container">
                            <div class="error-template">
                                <h1>Oops!</h1>
                                <!--<h2>403</h2>-->
                                <div class="error-details">Sorry You can't Edit This Record...</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import index from "../../router";
    import Vue from "vue";
    import EventBus from "../event-bus";
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from "vee-validate";
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.use(VeeValidate);
// import moment from 'moment'
    /* Vue FlatPickr */
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    var segments = "";
    var contex;
    export default {
        name: "AddResaleReason",
        components: {
            'app-footer': FrontFooter,
            flatPickr,
        },
        mixins: [SessioMixin],
        data() {
            return {
                is_update: false,
                created_at: '',
                updated_at: '',
                resale_reason: '',
                isShowLoggedinfields: true,
                firstName: "",
                lastName: "",
                u_firstName: "",
                u_lastName: "",
                userName: "",
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,
                created_by: "",
                updated_by: "",
                user_id: "",
                isDataEditable: true,
                loginID: ""
            };
        },
        watch: {

        },
        beforeMount: function () {
            var app = this;
            contex = this;
            var check = localStorage.getItem("api_token");

            if (check != null) {
                app.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $(".removeActive").removeClass("active");
            if (segments[3] == 'update') {
              self.is_update = true;
                if (segments[4] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menuresalereason").addClass("active");
                }
            } else {
                self.created_at = self.getCurrentDateTime('');
                //console.log(segments[3]);
                if (segments[4] != 0) {
                    $("#menucustomers").addClass("active");
                } else {
                    $("#menuresalereason").addClass("active");
                }
            }

            if (localStorage.getItem("menu_small") == "1") {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            if (segments[3] == 'update') {
                if (segments[4]) {
                    self.showLoader();
                    self.loadResaleReason();
                    // $("#addAndContinueTaskBtn").prop('disabled',true);
                    $("#addAndContinueTaskBtn").hide();
                    $("#addTaskBtn").val("Update");
                    $("#taskHeader").text("Edit Resale");
                }
            }
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                EventBus.$emit(
                        "logged-in",
                        false,
                        userJson["first_name"],
                        userJson["last_name"],
                        userJson["email"]
                        );
            }
        },
        methods: {
            getCurrentDateTime(givenDate) {
              console.log('givenDate==', givenDate);
              if(givenDate == '') {
                var today = new Date();
              } else {
                var today = new Date(givenDate);
              }


                var dd = today.getDate();
                var mm = today.getMonth()+1;
                var yyyy = today.getFullYear();

                var HH = today.getHours();
                var MM = today.getMinutes();
                var SS = today.getSeconds();

                if(dd<10)
                {
                    dd='0'+dd;
                }

                if(mm<10)
                {
                    mm='0'+mm;
                }

                if(HH<10)
                {
                    HH='0'+HH;
                }

                if(MM<10)
                {
                    MM='0'+MM;
                }

                if(SS<10)
                {
                    SS='0'+SS;
                }

                var date = mm+'-'+dd+'-'+yyyy;
                var time = HH + ":" + MM + ":" + SS;

                today = date + " " + time;
                return today;
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_add_new_task') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },

            backshowtask() {
                var self = this;
                // var path = window.location.pathname;
                // var segments = path.split("/");

                self.$router.push("/resale/reason/list");

                // if (segments[2] == 'update') {
                //     if (segments[4] != 0) {
                //         self.$router.push("/customer/view/" + segments[4]);
                //     } else {
                //         self.$router.push("/resale/reason/list");
                //     }
                // } else {
                //     if (segments[4] != 0) {
                //         self.$router.push("/customer/view/" + segments[3]);
                //     } else {
                //         self.$router.push("/resale/reason/list");
                //     }
                // }
            },

            AddResaleReason(flag) {
                var self = this;
                self.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        //console.log(segments[3]);
                        if (segments[3] == 'update') {
                            if (segments[4]) {
                                //console.log(segments[3]);
                                $("#addTaskBtn").val("Updating ...");
                                $("#addTaskBtn").prop("disabled", true);
                                // $("#addAndContinueCaseBtn").prop('disabled',true);
                                $("#CancelTask").prop("disabled", true);
                            } else {
                                if (flag == "Save and Continue") {
                                    $("#addAndContinueTaskBtn").val("Saving ...");
                                    $("#addAndContinueTaskBtn").prop("disabled", true);
                                    $("#addTaskBtn").prop("disabled", true);
                                    $("#CancelTask").prop("disabled", true);
                                } else {
                                    $("#addTaskBtn").val("Saving ...");
                                    $("#addTaskBtn").prop("disabled", true);
                                    $("#addAndContinueTaskBtn").prop("disabled", true);
                                    $("#CancelTask").prop("disabled", true);
                                }
                            }
                        } else {
                            if (flag == "Save and Continue") {
                                $("#addAndContinueTaskBtn").val("Saving ...");
                                $("#addAndContinueTaskBtn").prop("disabled", true);
                                $("#addTaskBtn").prop("disabled", true);
                                $("#CancelTask").prop("disabled", true);
                            } else {
                                $("#addTaskBtn").val("Saving ...");
                                $("#addTaskBtn").prop("disabled", true);
                                $("#addAndContinueTaskBtn").prop("disabled", true);
                                $("#CancelTask").prop("disabled", true);
                            }
                        }

                        var fields = $("#resaleReasonform").serializeArray();
                        // fields.push({name: "resale_reason", value: self.resale_reason});
                        // fields.push({name: "user_id", value: self.ptTaxId.id});
                        self.$validator.validateAll();
                        self.$validator.errors.clear();
                        if (segments[3] == 'update') {
                            if (segments[4]) {
                                fields.push({name: "id", value: segments[4]});
                            } else {
                              var newId = parseInt(segments[5]) + 1;
                                fields.push({name: "id", value: 0});
                                fields.push({name: "newid", value: newId});
                            }
                        } else {
                          console.log(segments[5])
                          var newId = parseInt(segments[5]) + 1;
                          fields.push({name: "id", value: 0});
                            fields.push({name: "newid", value: newId});
                        }
                        self.showLoader();
                        $.ajax({
                            url: process.env.ROOT_API + "/resale/reason/create",
                            type: "POST",
                            data: fields,
                            headers: {
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                Authorization: "Bearer " + localStorage.getItem("api_token"),
                                "Access-Control-Allow-Headers":
                                        "Origin, Content-Type, Authorization,X-Requested-With",
                                "Cache-Control": "no-cache"
                            },
                            dataType: "json",
                            success: function (data) {
                              console.log(data);
                                self.hideLoader();
                                if (segments[3] == 'update') {
                                    if (segments[4]) {
                                        //console.log(segments[3]);
                                        $("#addTaskBtn").val("Update");
                                        $("#addTaskBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelTask").prop("disabled", false);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueTaskBtn").val("Save and Continue");
                                            $("#addAndContinueTaskBtn").prop("disabled", false);
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#CancelTask").prop("disabled", false);
                                        } else {
                                            $("#addTaskBtn").val("Save");
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#addAndContinueTaskBtn").prop("disabled", false);
                                            $("#CancelTask").prop("disabled", false);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueTaskBtn").val("Save and Continue");
                                        $("#addAndContinueTaskBtn").prop("disabled", false);
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#CancelTask").prop("disabled", false);
                                    } else {
                                        $("#addTaskBtn").val("Save");
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#addAndContinueTaskBtn").prop("disabled", false);
                                        $("#CancelTask").prop("disabled", false);
                                    }
                                }
                                if (data.status == "success") {
                                    // self.$router.push('/task/list');

                                    if (flag == "Save and Continue") {
                                        $("html, body").animate({scrollTop: "0px"}, 500);
                                        $(".alert-success").parent().removeClass("hide");
                                        $(".alert-success").parent().addClass("show");
                                        self.resale_reason= '';
                                        self.user_id = '';

                                        setTimeout(function () {
                                            $(".alert-success").parent().removeClass("show");
                                            $(".alert-success").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        self.backshowtask();
                                    }
                                } else {
                                    // $(".alert-danger").parent().removeClass('hide');
                                    // $(".alert-danger").parent().addClass('show');
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i] + "<br>";
                                        }
                                        $("#errorMsg").html(err);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (segments[2] == 'update') {
                                    if (segments[3]) {
                                        $("#addTaskBtn").val("Update");
                                        $("#addTaskBtn").prop("disabled", false);
                                        // $("#addAndContinueCaseBtn").prop('disabled',true);
                                        $("#CancelTask").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        if (flag == "Save and Continue") {
                                            $("#addAndContinueTaskBtn").prop("disabled", false);
                                            $("#addAndContinueTaskBtn").val("Save and Continue");
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#CancelTask").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            self.resale_reason= '';
                                            self.user_id = '';
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        } else {
                                            $("#addTaskBtn").val("Save");
                                            $("#addTaskBtn").prop("disabled", false);
                                            $("#addAndContinueTaskBtn").prop("disabled", true);
                                            $("#CancelTask").prop("disabled", false);
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }

                                        if (jqXHR.status == 0) {
                                            self.errorMsg = "Remote server can not be reachable";
                                        } else {
                                            //redirect to login page if user not authenticated
                                            if (jqXHR.status == 401) {
                                                //clear previous data
                                                localStorage.removeItem("user_obj");
                                                localStorage.removeItem("api_token");
                                                //EventBus.$emit("logged-in", true, "", "");
                                                self.$router.push("/login");
                                            }
                                            $("#errorMsg").html(jqXHR.responseJSON.message);
                                            $(".alert-danger").parent().removeClass("hide");
                                            $(".alert-danger").parent().addClass("show");
                                            setTimeout(function () {
                                                $(".alert-danger").parent().removeClass("show");
                                                $(".alert-danger").parent().addClass("hide");
                                            }, 5000);
                                        }
                                    }
                                } else {
                                    if (flag == "Save and Continue") {
                                        $("#addAndContinueTaskBtn").prop("disabled", false);
                                        $("#addAndContinueTaskBtn").val("Save and Continue");
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#CancelTask").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        self.resale_reason= '';
                                        self.user_id = '';
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    } else {
                                        $("#addTaskBtn").val("Save");
                                        $("#addTaskBtn").prop("disabled", false);
                                        $("#addAndContinueTaskBtn").prop("disabled", true);
                                        $("#CancelTask").prop("disabled", false);
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }

                                    if (jqXHR.status == 0) {
                                        self.errorMsg = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (jqXHR.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            //EventBus.$emit("logged-in", true, "", "");
                                            self.$router.push("/login");
                                        }
                                        $("#errorMsg").html(jqXHR.responseJSON.message);
                                        $(".alert-danger").parent().removeClass("hide");
                                        $(".alert-danger").parent().addClass("show");
                                        setTimeout(function () {
                                            $(".alert-danger").parent().removeClass("show");
                                            $(".alert-danger").parent().addClass("hide");
                                        }, 5000);
                                    }
                                }
                            }
                        });
                    }
                });
            },

            loadResaleReason() {
                var path = window.location.pathname;
                var segments = path.split("/");
                var self = this;
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/resale/reason/" + segments[4],
                    type: "GET",
                    headers: {
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        Authorization: "Bearer " + localStorage.getItem("api_token"),
                        "Access-Control-Allow-Headers":
                                "Origin, Content-Type, Authorization,X-Requested-With",
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        // console.log(data);
                        // if (data.content.created_by == self.loginID) {

                          // self.created_at = self.getCurrentDateTime(data.content.created_at);;
                          // self.updated_at = self.getCurrentDateTime(data.content.updated_at);
                          self.resale_reason = data[0].SettingValue;
                          // self.ItmId = data.content.SettingValue;
                          // self.u_firstName = data.content.updated_user_firstname;
                          // self.u_lastName = data.content.updated_user_lastname;

                          self.isDataEditable = true;
                        // }
                        // else {
                        //     self.isDataEditable = false;
                        // }
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            menuSmall: function () {
                $(".opensidebar").show();
                $(".closesidebar").hide();
                $(".menu").addClass("menusmall");
                $(".sidemenu li a span,.legal").addClass("displaynone");
                $(".sidemenu li a i").addClass("displayicons");
                $(".sidebar").css({width: "70px"});
                $(".content").css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $(".opensidebar").hide();
                $(".closesidebar").show();
                $(".menu").removeClass("menusmall");
                $(".sidemenu li a span,.legal").removeClass("displaynone");
                $(".sidemenu li a i").removeClass("displayicons");
                $(".sidebar").css({width: "260px"});
                $(".content").css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
        }
    };
    EventBus.$on('logged-in', function (isLogin, fname, lname, email) {
        if (typeof (contex) != "undefined") {
            contex.isShowLoggedinfields = isLogin;
            contex.firstName = fname;
            contex.lastName = lname;
            contex.userName = email;
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/resalereason/AddResaleReason.vue